import { supabase } from '../supabaseClient';

/** /api/send-*-email · /api/slide-webpage-preview 호출 헤더 — 서버가 로그인 토큰으로 권한을 판정한다. */
export async function mailApiHeaders(): Promise<Record<string, string>> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  return token
    ? { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
    : { 'Content-Type': 'application/json' };
}
